<template>
  <div>
    <list
      row-key="LeaveId"
      ref="list"
      unit="留宿资格管理"
      :expand-all-row="true"
      :page="page"
      :query-params="params"
      :show-checkbox="false"
      :show-query="true"
      :get-data-func="api.list"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="学期名称">
          <el-select v-model="params.TermId" @change="termChange">
            <el-option
              v-for="item in termList"
              :key="item.TermId"
              :value="item.TermId"
              :label="item.TermName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="params.GradeId" @change="getClass" clearable>
            <template v-for="(i,index) in grades">
              <el-option :key="index" :value="i.GradeId" :label="i.Grade"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="班级">
          <el-select v-model="params.ClassId" clearable>
            <template v-for="(i,index) in classes">
              <el-option :key="index" :value="i.ClassId" :label="i.ClassName"></el-option>
            </template>
          </el-select>
        </el-form-item>
        <el-form-item label="学生姓名">
          <el-input v-model="params.FullName" style="width:184px;" placeholder="请填写姓名"></el-input>
        </el-form-item>
        <el-form-item label="留宿资格">
          <el-select v-model="params.StayQualification" clearable>
            <el-option :value="1" label="正常"></el-option>
            <el-option :value="0" label="取消"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取消原因">
          <el-select v-model="params.CancelRemark" filterable allow-create clearable>
            <el-option value="扣分累计"></el-option>
            <el-option value="过密"></el-option>
            <el-option value="手机"></el-option>
            <el-option value="其他"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取消日期">
          <el-date-picker
            v-model="params.CancelStartDate"
            placeholder="请选择日期"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
          -
          <el-date-picker
            v-model="params.CancelEndDate"
            placeholder="请选择日期"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <el-form-item label="恢复日期">
          <el-date-picker
            v-model="params.ResumeStartDate"
            placeholder="请选择日期"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
          -
          <el-date-picker
            v-model="params.ResumeEndDate"
            placeholder="请选择日期"
            style="width:184px;"
            clearable
            value-format="yyyy-MM-dd"
          />
        </el-form-item>
        <!-- <el-form-item label="取消方式">
          <el-select v-model="params.CancelWay" clearable>
            <el-option :value="0" label="系统"></el-option>
            <el-option :value="1" label="手动"></el-option>
          </el-select>
        </el-form-item> -->
      </template>
      <template slot="table">
        <el-table-column prop="FullName" label="学生姓名" />
        <el-table-column prop="Sex" label="性别">
          <template slot-scope="{row}">
            {{row.Sex==1?"男":row.Sex==2?"女":""}}
          </template>
        </el-table-column>
        <el-table-column prop="Grade" label="年级" />
        <el-table-column prop="ClassName" label="班级" />
        <el-table-column prop="Dormitory" label="宿舍号" />
        <el-table-column prop="DisciplinePoint" label="本周期量化扣分值" min-width="120" />
        <el-table-column prop="CancelDate" label="取消日期" min-width="110">
          <template slot-scope="{row}">
            <span v-if="row.StayQualification==0">{{$commonJs.toDateString(row.CancelDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CancelRemark" label="取消原因" min-width="110">
          <template slot-scope="{row}">
            <span v-if="row.StayQualification==0">{{row.CancelRemark}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="CancelWay" label="取消方式">
          <template slot-scope="{row}">
            <template v-if="row.StayQualification==0">
              <span v-if="!row.CancelDate"></span>
              <span v-else-if="row.CancelWay==0">系统</span>
              <span v-else-if="row.CancelWay==1">手动</span>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="ResumeDate" label="恢复日期" min-width="110">
          <template slot-scope="{row}">
            <span>{{$commonJs.toDateString(row.ResumeDate)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="Remark" label="备注" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="StayQualification" label="留宿资格" align="center" width="70" fixed="right">
          <template slot-scope="{row}">
            <el-tag type="danger" v-if="row.StayQualification==0">取消</el-tag>
            <el-tag type="success" v-else-if="row.StayQualification==1">正常</el-tag>
          </template>
        </el-table-column>
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";

export default {
  mixins: [listMixin],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/st/studentclass").default,
      grade_api: require("@/api/ed/grade").default,
      class_api: require("@/api/ed/class").default,
      termApi: require("@/api/ed/term").default,
      params: {
        TermId: 0,
        GradeId: null,
        ClassId: null,
        StayQualification: null,
        FullName: "",
        CancelStartDate: "",
        CancelEndDate: "",
        ResumeStartDate: "",
        ResumeEndDate: "",
        CancelRemark: "",
        // CancelWay: null,
        Qualification: true
      },
      termList: [],
      grades: [],
      classes: [],
      isMB: this.$store.state.isMB,
    };
  },
  mounted() {
    let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.params.TermId = loginInfo.TermId;
    this.termApi.list().then((res) => {
      if (res.Data && res.Data.length > 0) {
        this.termList = res.Data;
        if (!this.params.TermId) {
          this.params.TermId = res.Data[0].TermId;
        }
        this.$refs.list.initQueryParams.TermId = this.params.TermId;
        this.query({ TermId: this.params.TermId });
      }
    });
    this.getGrade();
  },
  methods: {
    onExport() {
      this.api.export(
        this.$commonJs.obj.removeNullKey(this.$refs.list.tempQueryParams)
      );
    },
    termChange(e) {
      this.params.ClassId = null;
      this.sectionList = [];
      this.getClass();
      this.getGrade();
      this.query({
        TermId: e,
      });
    },
    getGrade() {
      this.grade_api.list().then((res) => {
        this.grades = res.Data;
      });
    },
    getClass() {
      this.params.ClassId = null;
      if (!this.params.GradeId) {
        this.classes = [];
        return;
      }
      var params = { GradeId: this.params.GradeId, TermId: this.params.TermId };
      this.class_api.list(params).then((res) => {
        this.classes = res.Data;
      });
    },
  },
};
</script>